import { queryKeys } from "../queryKeys";
import { type Activity, getActivities } from "../rest/account";
import { useRequest } from ".";
import type { QueryOptions } from "./useRequest";

export type UseGetPaginatedActivitiesFilters = {
  activityTypes?: string[];
  after?: string;
  until?: string;
};

export type UseGetPaginatedActivitiesArgs = {
  accountID?: string;
  paper?: boolean;
  pageSize?: number;
  pageToken?: string;
  filters?: UseGetPaginatedActivitiesFilters;
  options?: QueryOptions<Activity[]>;
};

export const useGetPaginatedActivities = ({
  accountID,
  paper,
  pageSize,
  pageToken,
  filters,
  options = {},
}: UseGetPaginatedActivitiesArgs) => {
  return useRequest(
    queryKeys.activities.paginated(
      accountID,
      paper,
      pageSize,
      pageToken,
      filters,
    ),
    () =>
      getActivities({
        accountID: accountID || "",
        paper,
        activityTypes: filters?.activityTypes,
        after: filters?.after,
        until: filters?.until,
        page_size: pageSize,
        page_token: pageToken,
      }),
    {
      ...options,
      enabled: options.enabled !== undefined ? options.enabled : !!accountID,
    },
  );
};

export default useGetPaginatedActivities;
